/**
 * Development / creative-coding projects. Reference images as
 * '/images/code/<file>'. `href` can point at a live demo or repo. Newest first.
 */
const CODE_PROJECTS = [
    {
        slug: 'rhico-website',
        title: 'rhico.website',
        category: 'Web',
        year: 2026,
        description: 'This portfolio — a React + Vite SPA with a Hono API, deployed on Vercel.',
        image: '',
        tags: ['React', 'Vite', 'Tailwind', 'Hono'],
        href: 'https://github.com/H0lloH/rhico.website'
    },
    {
        slug: 'sample-experiment',
        title: 'Sample Creative-Coding Experiment',
        category: 'Generative',
        year: 2025,
        description: 'Placeholder entry — a canvas/WebGL sketch. Swap in something real.',
        image: '',
        tags: ['Canvas', 'anime.js'],
        href: ''
    }
];

export default CODE_PROJECTS;
